var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company"},[_c('company_header',{ref:"header"}),_c('div',{staticClass:"view"},[_c('company_nav',{ref:"nav"}),_c('router-view',{staticClass:"main"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }